/**
 * AN OLD LINK TO A CAPITAL ESTIMATE OPENS IT WHERE IT IS ENTERED NOW: its own pages in Project
 * Financials (PLAN-28 P3b/P3c). `/capital/estimates/:id` used to mount the bid editor in `capitalMode`;
 * P3-close retired that editor for capital estimates, but bookmarks, notifications and the old board's
 * links still carry it. Its `?from`, `return`, `mode`, `edit` and `tab` meant things to the old editor
 * and to nothing on the new pages, so they are dropped - `edit=true` in particular re-took the rate
 * sheet on load, which is exactly what must not happen by opening a page. Replace, so Back does not
 * bounce off this address. Kept for at least two releases after P3-close (design section 2).
 *
 * NOT BEHIND CAPITAL'S SWITCH (the fourth fix round). App.jsx answers this address itself, before the
 * `/capital/*` route and its ModuleSwitchRoute, because the estimate does not open in Capital: with
 * Capital switched off (or both off) the old link bounced silently to the portal, and the capex route's
 * own gate never got to say anything. Now it always goes on to `/capex/estimates/:id`, whose gate
 * answers: the estimate when Project Financials is on, the page saying it is off when it is off, and
 * the page saying it could not check when the lookup failed. The rest of Capital stays gated.
 * CapitalModule keeps the same route, so the module mounted by itself still forwards the address.
 *
 * Small and eager on purpose: it imports nothing but the router, so App.jsx can load it without
 * loading Capital.
 */
import { Navigate, useParams } from 'react-router-dom'

export default function EstimateMovedToProjectFinancials() {
  const { id } = useParams()
  return <Navigate to={`/capex/estimates/${encodeURIComponent(id)}`} replace />
}
